module.exports = __webpack_public_path__ + "static/AnubhavGupta-bea321431af608f7c7226a1f1f38c7d7.jpg";